import {useEffect} from 'react';

import useMainSidebar from '../../providers/useMainSidebar';
import useReportViews from '../../providers/useReportViews';

// This hook aims to remove pointerEvents from PowerBi Report iframe while some popper is open
// Otherwise, the pointer events are captured by iframe rather than the the ClickAwayListener from MUI
const usePreventIframeClickPropagation = () => {
  const {isMoreReportsPopperOpen, isMoreModulesPopperOpen, moduleCategoryExpanded} = useMainSidebar();
  const {isChooseViewPopperOpen} = useReportViews();

  useEffect(() => {
    const iframe = document.querySelector('iframe');
    const isSomePopperOpen = isChooseViewPopperOpen || isMoreReportsPopperOpen || isMoreModulesPopperOpen || moduleCategoryExpanded !== null;
    if (!iframe) return;

    iframe.style.pointerEvents = isSomePopperOpen ? 'none' : 'all';
  }, [isChooseViewPopperOpen, isMoreReportsPopperOpen, isMoreModulesPopperOpen, moduleCategoryExpanded]);
};

export default usePreventIframeClickPropagation;
